import {
    ITEM,
    NEW_ITEM,
    ADDITIONAL_ITEM,
    ITEM_ESTIMATION,
    ONLY_SHIPPING_LABEL,
    PENDING_AUCTION,
    SHIPPING_LABEL,
    UPDATE_HV_CUI_LAST_MESSAGE_KEY,
    CONFIRM_SHIPBACK_ADDRESS,
    CONFIRM_SHIPBACK_ADDRESS_REJECTED,
    UPDATE_SHIPBACK_ADDRESSES,
    UPDATE_SHIPBACK_DESTINATION,
} from "actions/item";

import {
    SCHEDULE_PICKUP,
    SCHEDULE_DROP_OFF,
    REQUEST_SHIPPING_KIT,
} from "actions/shipment";

import WorthyApiErrors from "lib/api/worthyApiErrors";
import { isEqual } from "lodash";
import GA from "../lib/ga";

export default (state = null, action) => {
    switch (action.type) {
        case ITEM:
        case NEW_ITEM:
        case ADDITIONAL_ITEM:
            if (action.error) {
                return action.payload;
            } else {
                const item = action.payload.data.item;
                GA.setItemDetails({ valueCategory: item?.value_category });
                return item;
            }
        case ITEM_ESTIMATION:
            if (action.error) {
                state.estimation = false;
                if (
                    action.payload instanceof WorthyApiErrors &&
                    (action.payload.isHttpError ||
                        action.payload.isNetworkError)
                ) {
                    return action.payload;
                } else {
                    return Object.assign({}, action.payload.data, state);
                }
            } else {
                // TODO: delete the commented out code at some point.
                // not before match 2021.
                // delete action.payload.data.item['workflow_state'];
                return Object.assign({}, state, action.payload.data.item);
            }
            return state;
        case SHIPPING_LABEL:
        case SCHEDULE_DROP_OFF:
        case SCHEDULE_PICKUP:
        case PENDING_AUCTION:
        case REQUEST_SHIPPING_KIT:
            if (action.error) {
                return state;
            } else {
                return action.payload.data.item;
            }
            return state;
        case ONLY_SHIPPING_LABEL:
            if (action.error) {
                return state;
            } else {
                return Object.assign({}, state, {
                    shipment: action.payload.data.item.shipment,
                });
            }
            return state;
        case UPDATE_HV_CUI_LAST_MESSAGE_KEY:
            return Object.assign({}, state, {
                hvCuiLastMessageKey: action.payload,
            });
        case CONFIRM_SHIPBACK_ADDRESS:
            return {
                ...state,
                ...action.payload.item,
                shipback_info: {
                    ...state.shipback_info,
                    ...action.payload.item.shipback_info,
                },
            };
        case CONFIRM_SHIPBACK_ADDRESS_REJECTED:
            return {
                ...state,
                shipback_info: {
                    ...state.shipback_info,
                    hasError: true,
                },
            };
        case UPDATE_SHIPBACK_ADDRESSES: {
            const apiAddress =
                state.shipback_info.apiAddress || state.shipback_info.address;
            const { address } = action.payload;
            const hashWorkflowState =
                __ENV__ !== "production"
                    ? window.location.hash.replace("#", "")
                    : "";

            return {
                ...state,
                ...action.payload.item,
                shipback_info: {
                    ...state.shipback_info,
                    ...action.payload,
                    apiAddress,
                    isSellerAddressChanged: !isEqual(apiAddress, address),
                    bundle_workflow_state:
                        hashWorkflowState ||
                        state.shipback_info.bundle_workflow_state,
                },
            };
        }
        case UPDATE_SHIPBACK_DESTINATION: {
            const { shipping_option } = action.payload;

            return {
                ...state,
                ...action.payload.item,
                shipback_info: {
                    ...state.shipback_info,
                    shipping_option,
                },
            };
        }
    }

    return state;
};
